// extracted by mini-css-extract-plugin
export default {"pageContent":"MyAccounts_pageContent__50M-D"};